import { useTranslation } from 'react-i18next';
import { Card, useRouteDocumentTitle } from '@client/toolkit';
import { ReportingPaths } from '../reporting.router';
import { ReportPageContent } from '../../../components/layout/report-page-content';
import { ConsumptionBuildingsTable } from './components/table';
import { DashboardFiltersProvider } from '../../dashboard/context/dashboard-filters.context';
import { DashboardFilters } from '../../dashboard/components';
import { eosDateRangeFilterVisiblePresets } from '../../../components/eos/config';

export const ReportingConsumptionSensorRoute = () => {
  const { t } = useTranslation('reporting');
  useRouteDocumentTitle(t('reporting.documentTitle'), ReportingPaths.ConsumptionBySensor);
  return (
    <DashboardFiltersProvider>
      <ReportPageContent
        breadcrumb={t('energyConsumptionSensorTitle')}
        menu={<DashboardFilters showOnlySpacesWithEosEnabled visiblePresets={eosDateRangeFilterVisiblePresets} />}
      >
        <Card>
          <ConsumptionBuildingsTable />
        </Card>
      </ReportPageContent>
    </DashboardFiltersProvider>
  );
};
